import servicesUtils from "./servicesUtils";
import http from "./http-service";

export const authServices = {
  async signIn(username, password) {
    try {
      const url = `/signIn?t=` + new Date().getTime().toString();
      const res = await http.fetch(url, {
        method: "POST",
        body: JSON.stringify({
          username: username,
          password: password,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      return res.data;
    } catch (e) {
      void 0;
    }
  },

  async signOut() {
    const res = await http.fetch('/signOut', { method: 'POST' });
    return servicesUtils.checkStatus(res);
  },
};
